<div class="locationGridCell" *ngrxLet="viewModel$; let model;">

  @if (!model.loading) {
    @if (model.params?.colDef?.field === LSCField.otherPhotos) {
      <div class="flex flex-col">
        @for (singleLink of (model.params?.value | split); track singleLink) {
          <a
            class="no-underline text-blue-40"
            href="{{ singleLink | prependProtocol }}"
            target="_blank"
            rel="noopener noreferrer"
            (mouseenter)="openImage(singleLink)"
            (mouseleave)="closeImage()"
            (click)="trackPhotoClick(model.params?.colDef?.field)">
            <span [ngClass]="{ 'text-neutral-60': model.isFieldBlacklisted }">
              {{singleLink}}
            </span>
          </a>
        }
      </div>
    }
    @if (model.params?.colDef?.field === LSCField.logoPhoto || model.params?.colDef?.field === LSCField.coverPhoto) {
      <div
        class="flex flex-row">
        <a href="{{ model.params?.value | prependProtocol }}"
          class="no-underline text-blue-40"
          target="_blank"
          rel="noopener noreferrer"
          (mouseenter)="openImage(model.params?.value)"
          (mouseleave)="closeImage()"
          (click)="trackPhotoClick(model.params?.colDef?.field)">
          <span [ngClass]="{ 'text-neutral-60': model.isFieldBlacklisted }">
            {{ model.params?.value }}
          </span>
        </a>
        @if (model.params?.colDef?.field === LSCField.coverPhoto && model.params?.value) {
          <mat-icon id="linkOldPhoto"
            matTooltip="Open original cover photo"
            (click)="openOriginalCoverPhotoInNewTab(model.params?.value)"
            svgIcon="open_in_new">
          </mat-icon>
        }
      </div>
    }
  }

  @if (model.loading) {
    <ngx-skeleton-loader
      class="w-full"
    [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
  }

</div>


